import { map, find, get, isUndefined, isNull } from 'lodash'
import dayjs from 'dayjs'
import { i18n } from '@/plugins/i18n/i18n'
import { weeksOptions } from '@/config/date'

export const useBusinessTime = () => {
  const mergeTimeIntervals = (intervals) => {
    const mergedIntervals = []
    const sortedIntervals = intervals.sort((a, b) => a.week - b.week || a.timeStart - b.timeStart)

    let currentInterval = sortedIntervals[0]

    for (let i = 1; i < sortedIntervals.length; i++) {
      const nextInterval = sortedIntervals[i]

      if (currentInterval.week === nextInterval.week && currentInterval.timeEnd >= nextInterval.timeStart) {
        currentInterval.timeEnd = Math.max(currentInterval.timeEnd, nextInterval.timeEnd)
      } else {
        mergedIntervals.push(currentInterval)
        currentInterval = nextInterval
      }
    }
    mergedIntervals.push(currentInterval)
    const [result] = mergedIntervals
    if (result === undefined) return []
    else return mergedIntervals
  }
  const formatExcludeTime = (value) => {
    const defaultOnceSetting = {
      startAt: 0,
      endAt: 0,
    }

    return map(value, item => {
      const { weeklySetting, monthlySetting, onceSetting, yearlySetting, type } = item
      const payload = {
        ...item,
        onceSetting: defaultOnceSetting,
        yearlySetting: {
          ...yearlySetting,
          startTime: timeToMinutes(get(yearlySetting, 'startTime')),
          endTime: timeToMinutes(get(yearlySetting, 'endTime')),
        },
        monthlySetting: {
          ...monthlySetting,
          endTime: timeToMinutes(get(monthlySetting, 'endTime')),
          startTime: timeToMinutes(get(monthlySetting, 'startTime')),
        },
        weeklySetting: {
          ...weeklySetting,
          startTime: timeToMinutes(get(weeklySetting, 'startTime')),
          endTime: timeToMinutes(get(weeklySetting, 'endTime')),
        },
      }

      if (type === 'once') {
        const [startAt, endAt] = get(onceSetting, 'dateRange')
        payload.onceSetting = { startAt, endAt }

        delete payload.weeklySetting
        delete payload.monthlySetting
        delete payload.yearlySetting
      } else if (type === 'yearly') {
        delete payload.onceSetting
        delete payload.weeklySetting
        delete payload.monthlySetting
      } else if (type === 'monthly') {
        delete payload.onceSetting
        delete payload.weeklySetting
        delete payload.yearlySetting
      } else if (type === 'weekly') {
        delete payload.onceSetting
        delete payload.monthlySetting
        delete payload.yearlySetting
      }

      return payload
    })
  }
  const syncShopExcludeTimeRules = (data) => {
    const excludeTimeRules = data
    return map(excludeTimeRules, item => {
      const { weeklySetting, monthlySetting, onceSetting, yearlySetting, type } = item
      const payload = {
        ...item,
        weeklySetting: {
          ...weeklySetting,
          startTime: minutesToTime(get(weeklySetting, 'startTime')),
          endTime: minutesToTime(get(weeklySetting, 'endTime')),
        },
        monthlySetting: {
          ...monthlySetting,
          endTime: minutesToTime(get(monthlySetting, 'endTime')),
          startTime: minutesToTime(get(monthlySetting, 'startTime')),
        },
        onceSetting: {
          startAt: get(onceSetting, 'startAt'),
          endAt: get(onceSetting, 'endAt'),
          dateRange: [get(onceSetting, 'startAt'), get(onceSetting, 'endAt')],
        },
        yearlySetting: {
          ...yearlySetting,
          startTime: minutesToTime(get(yearlySetting, 'startTime')),
          endTime: minutesToTime(get(yearlySetting, 'endTime')),
        },
      }

      // if (type === 'once') {
      //   delete payload.weeklySetting
      //   delete payload.monthlySetting
      //   delete payload.yearlySetting
      // } else if (type === 'yearly') {
      //   delete payload.onceSetting
      //   delete payload.weeklySetting
      //   delete payload.monthlySetting
      // } else if (type === 'monthly') {
      //   delete payload.onceSetting
      //   delete payload.weeklySetting
      //   delete payload.yearlySetting
      // } else if (type === 'weekly') {
      //   delete payload.onceSetting
      //   delete payload.monthlySetting
      //   delete payload.yearlySetting
      // }

      return payload
    })
  }
  const renderExcludeTime = (data) => {
    return map(data, item => {
      const { weeklySetting, monthlySetting, onceSetting, yearlySetting, type } = item
      const formatTime = (time) => (typeof time === 'string' ? time : minutesToTime(time))

      if (type === 'weekly') {
        const { week, endTime, startTime } = weeklySetting
        const weekName = get(find(weeksOptions, option => option.value === week), 'label')
        return `每週重複 ${i18n.t(weekName)} ${formatTime(startTime)} - ${formatTime(endTime)}`
      } else if (type === 'monthly') {
        const { startDay, startTime, endDay, endTime } = monthlySetting
        return `每月重複  ${startDay} 日 ${formatTime(startTime)} - ${endDay} 日 ${formatTime(endTime)}`
      } else if (type === 'once') {
        // ⚠️ startAt／endAt 是店家牆上時間字串（CNCY-10430），dayjs 對裸字串不做時區
        // 換算 ⇒ 印出來就是商家當初選的數字。不要為了「保險」補 .utc()／.tz()，
        // 那會把它當成絕對時間戳，又變回每個人看到不同時間。
        const startAt = dayjs(onceSetting.startAt).format('YYYY/MM/DD HH:mm')
        const endAt = dayjs(onceSetting.endAt).format('YYYY/MM/DD HH:mm')
        return `${startAt} - ${endAt}`
      } else if (type === 'yearly') {
        const { startMonth, startDay, startTime, endMonth, endDay, endTime } = yearlySetting
        const startDate = `${startMonth} 月 ${startDay} 日 ${formatTime(startTime)}`
        const endDate = `${endMonth} 月 ${endDay} 日 ${formatTime(endTime)}`
        return `每年重複  ${startDate} - ${endDate}`
      }
    })
  }
  const originalTag = (data) => {
    switch (data) {
    case 'shop':
      return '分店排除特定時段'
    case 'branch':
      return '門市排除特定時段'
    case 'resourceItem':
      return '設備排除特定時段'
    case 'all':
      return '全店公休'
    default:
      return ''
    }
  }
  const timeToMinutes = (time) => {
    if (isUndefined(time) || isNull(time)) return undefined
    if (time === 0) return 0
    const [hours, minutes] = time.split(':')
    return parseInt(hours, 10) * 60 + parseInt(minutes, 10)
  }
  const minutesToTime = (minutes) => {
    if (isUndefined(minutes) || isNull(minutes)) return undefined
    const hours = Math.floor(minutes / 60)
    const remainingMinutes = minutes % 60

    const formattedHours = hours.toString().padStart(2, '0')
    const formattedMinutes = remainingMinutes.toString().padStart(2, '0')

    return `${formattedHours}:${formattedMinutes}`
  }
  return {
    mergeTimeIntervals,
    timeToMinutes,
    minutesToTime,
    formatExcludeTime,
    syncShopExcludeTimeRules,
    renderExcludeTime,
    originalTag,
  }
}
